// This file was automatically generated from ext.onboarding.addlLabsDialog.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ext.onboarding.addlLabsDialog');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ext.onboarding.addlLabsDialog.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><h1 class="el8PageTitle">Request A New Lab Interface</h1><form><p class="el8AppText el8OBMainText">Please let us know from which lab vendors you\'d like to receive labs electronically. We will notify you when the lab interface has been developed.</p><div class="el8OBTextareaWrap"><textarea type="text" name="addlLabs" class=""></textarea></div></div>');
  if (!opt_sb) return output.toString();
};
